<template>
    <div
        class="product-description accordion-gallery w-full z-10 bg-white pl-16 pr-8 py-8 pt-4 phone:-mt-10 mobile:self-center mobile:mx-4 tablet:-mt-2 tablet:pl-24 tablet:px-12 tabletLandscape:max-w-md tabletLandscape:mt-0 tabletLandscape:min-h-screen tabletLandscape:px-4 tabletLandscape:pt-2 tabletLandscape:pb-2 hd:max-w-3xl hd:px-16">
        <h2 class="flex items-center uppercase mb-2 -ml-2 tabletLandscape:my-3 hd:mb-6 desktop:text-2xl hd:mt-8">
            <svg-icon
                :key="currentProductSlug"
                :icon="getCurrentProductDescriptionProperty('icon')"
                class="text-black-700 w-24 h-18 tabletLandscape:hidden hd:block"
            />
            <span
                class="text-black-700 text-xl font-bold"
                v-html="getCurrentProductDescriptionProperty('title')" />
        </h2>

        <div
            v-for="(section, index) in getCurrentProductDescriptionProperty('sections')"
            :key="index"
            class="section pt-2 text-black-900 mb-2">
            <hr
                v-if="index > 0"
                class="text-gold-500 mb-4 tablet:max-w-tiny">
            <h3
                v-if="section.title"
                class="section-title text-gold-500 text-md uppercase tablet:text-xl tabletLandscape:text-sm  tabletLandscape:mb-0 desktop:text-lg hd:text-xl leading-relaxed mb-2"
                v-text="section.title" />

            <p
                v-if="section.subtitle1"
                class="text-gray-700 text-sm tablet:text-lg tabletLandscape:text-sm hd:text-md leading-relaxed italic"
                v-text="section.subtitle1" />
            <p
                v-if="section.subtitle2"
                class="mb-2 text-gray-700 text-sm tablet:text-lg tabletLandscape:text-sm hd:text-md leading-relaxed italic "
                v-text="section.subtitle2" />
            <p
                v-if="section.mainContent"
                class="text-gray-800 text-sm tablet:text-lg tabletLandscape:text-sm hd:text-lg leading-relaxed"
                v-text="section.mainContent"
            />
            <div
                v-if="section.mainContentFeatures"
                class="main-features">
                <ul class="list-square transition-all pl-4 mt-4 mb-8 tabletLandscape:mb-0 desktop:mb-8">
                    <li
                        v-for="(feature, key) in section.mainContentFeatures"
                        :key="key"
                        class="text-gold-500 text-sm tablet:text-lg tabletLandscape:text-sm desktop:text-md hd:text-lg leading-relaxed"
                    >
                        <span class="text-gray-800">{{ feature }}</span>
                    </li>
                </ul>
            </div>

            <div
                v-for="(productOption, optionIndex) in Object.values(getSectionProductionOptions(section))"
                v-if="section.productOptions"
                :key="optionIndex"
                class="mt-4 pl-12 product-options"
                @click="setActiveProductOption(optionIndex)"
            >
                <hr
                    v-if="optionIndex > 0"
                    class="text-gold-500 mb-4 first:hidden tablet:max-w-tiny">
                <h4
                    class="option-item cursor-pointer relative flex items-center text-black-900 mb-4 text-sm hd:text-xl hd:mb-8">
                    <span class="feature-index hidden hd:block absolute text-gray-800 opacity-5 font-bold">
                        {{ optionIndex + 1 }}
                    </span>
                    <span class="text-gold-500 font-bold cursor-pointer uppercase mr-2">{{ productOption.label }}</span>
                    <span class="text-gray-800 font-bold cursor-pointer uppercase mr-2">{{
                        productOption.subHeader
                    }}</span>
                    <span
                        v-if="productOption.pricing"
                        class="text-gray-700 text-sm">— {{ productOption.pricing }}</span>
                </h4>

                <div
                    v-show="activeProductOptionIndex === optionIndex"
                    v-if="productOption.features"
                    class="features">
                    <ul
                        class="list-square pl-10 mb-4">
                        <li
                            v-for="(feature, index) in productOption.features"
                            :key="index"
                            class="text-gold-500 text-sm tablet:text-lg tabletLandscape:text-sm desktop:text-md hd:text-lg leading-relaxed"
                        >
                            <span class="text-gray-800">{{ feature }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@whisper/components/icons/SvgIcon';
import { get } from 'lodash';

export default {
  name: 'PhotoGalleryProductDescriptions',
  components: {
    SvgIcon,
  },
  props: {
    products: {
      type: Object,
      required: true,
    },
    currentProductSlug: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    activeProductOptionIndex: 0,
  }),
  methods: {
    getSectionProductionOptions(section) {
      return get(section, 'productOptions', {});
    },
    setActiveProductOption(productOption) {
      this.activeProductOptionIndex = productOption;
    },
    getCurrentProductDescriptionProperty(property) {
      return get(this.products, [this.currentProductSlug, 'productDescription', property]);
    },
  },
};
</script>

<style scoped>

</style>
